import styled from "styled-components";

export const MainTitle = styled.h3`
  ${props => props.theme.typography.mainTitle}
`;
